// @core/api/endpoints/subscription/delete_subscription.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';

const BASE_PATH = '/subscription';

/**
 * Delete subscription
 * Immediately terminates a subscription without cancellation flow. Administrative action that should be used with caution.
 */
export async function DeleteSubscription(
  subscription_id: string,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/subscriptions/:subscription_id`;
  requestPath = requestPath.replace(':subscription_id', encodeURIComponent(subscription_id));
  const requestOptions = options;
  return client.delete<Response>(requestPath, requestOptions);
}
